import React from 'react'
import * as f from '../../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    DataTransformer,
    DefaultClickStrategy,
    OnlyFilterActionDisplayStrategy,
    TableFieldDescription,
    StatusChipComponentCreator,
    DateTimeComponentCreator,
    DateTimeDisplayCreator,
    MultilineComponentCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import { GraphQLDownloadFile } from '../../../components/FileDownloader/FileComponentDownloader'
import { dateDiff } from '../../../utils/processControlUtils'
import {ExportFooterItemCreator} from "../../../components/BPMTable/TableFooterItems"
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

let editMutator

let newMutator

let deleteMutator

const unitQuery = `
    massiveUploadControl(id: $id) {
        id
        user {
            id
            email
            enterpriseId
        }
        state
        createdAt
        updatedAt
        totalCount
        model
        message
    }
`

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('myMassiveUploadControls'), editMutator, newMutator, deleteMutator, unitQuery}

class MassiveUploadControlTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "MassiveUploadControlTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries, new DefaultClickStrategy(), new OnlyFilterActionDisplayStrategy())
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);
        tableCreator.setAdditionalFilters({first:30})
        tableCreator.setInitialSortField('createdAt', 'desc')
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'user',
                new DataMapper("user.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("user")),
                {label: 'User'}
            ),
            new TableFieldDescription(
                'model',
                new DataMapper("model"),
                new f.FilterDescription(new f.TextFilter("model")),
                {label: 'Model'}
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.PeriodFilter("createdAt")),
                {label: 'Creation Date', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator()}
            ),
            new TableFieldDescription(
                'updatedAt',
                new DataMapper("updatedAt"),
                new f.FilterDescription(new f.PeriodFilter("updatedAt")),
                {label: 'Last Update',transform: new DataTransformer(({updatedAt}) => dateDiff(updatedAt))}
            ),
            new TableFieldDescription(
                'totalCount',
                new DataMapper("totalCount"),
                new f.FilterDescription(new f.NullCreator("totalCount")),
                {label: 'Total Count', fieldAlign: 'right'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.ProcessControlStateFilter("state")),
                {label: 'Status', componentCreator: new StatusChipComponentCreator()}
            ),
            new TableFieldDescription(
                'message',
                new DataMapper("message"),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'Message',
                    hidenField: true,
                    componentCreator: new MultilineComponentCreator()
                }
            ),
            new TableFieldDescription(
                'downloadFile',
                new DataMapper("id", "hasFile"),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'Resource',
                    hideSort: true,
                    transform: new DataTransformer(({id, hasFile}) =>
                        hasFile ? <GraphQLDownloadFile resourceType='massive_upload' id={id} /> : null
                    ),
                }
            ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(MassiveUploadControlTableCreator)

export default MassiveUploadControlTableCreator;
